const { getElement, getElements } = window.BAO.Utils
export class ProductForm extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['submit']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    const cart = await fetch('/cart.js')
    const data = await cart.json()

    const showPreorderPrompt = this.shouldShowPreorderPrompt(data)

    if (showPreorderPrompt) return false

    const showSizesPrompt = this.shouldShowSizePrompt(data)

    this.skipCart = showSizesPrompt

    if (e.target.hasAttribute('data-mobile')) {
      this.skipCart = true
      this.externalEls['mobile-options']?.element.setAttribute(
        'aria-expanded',
        'false',
      )
      this.externalEls.success?.element.setAttribute('aria-expanded', 'true')

      if (e.target.dataset.form === 'product') {
        this.sizeValue = ''
        getElements(
          `[form="form-${this.dataset.productInfoId}"] [data-variant-selects-el="option-choice"]`,
        ).forEach((select) => {
          this.sizeValue += select.value
          this.sizeValue += '/'
        })
        this.sizeValue = this.sizeValue.slice(0, -1)
      } else {
        this.sizeValue = e.target
          .querySelector('[name="id"]')
          .getAttribute('aria-label')
      }

      const success = getElement(
        `[key="drawer-options-${this.dataset.form}"] [data-product-form-external-el="success-text"]`,
      )
      success.innerText = `${window.theme.strings.productStrings.option} ${this.sizeValue} ${window.theme.strings.productStrings.added}`
    }

    await this.addToCart(this.skipCart)
  }

  shouldShowPreorderPrompt (data) {
    const { items: lineItems = [] } = data

    // console.log(lineItems.length)

    if (lineItems.length === 0) return false

    const formData = new FormData(this.form)
    const isAddingPreorder = formData.get('properties[_preorder]') === 'true'

    // console.log(`isAddingPreorder: ${isAddingPreorder}`)

    const currentlyHasPreorder = lineItems.some((lineItem) => {
      if (lineItem.properties?._preorder === 'true') {
        // has preorder products
        return true
      }
      // not preorder products
      return false
    })

    // console.log(`currentlyHasPreorder: ${currentlyHasPreorder}`)

    if (currentlyHasPreorder !== isAddingPreorder) {
      const preorderDrawer = document.querySelector('preorder-prompt')
      preorderDrawer.setAttribute('data-form-id', this.form.getAttribute('id'))

      window.drawers.activeDrawerKey = 'preorder-prompt'
    }

    return currentlyHasPreorder !== isAddingPreorder
  }

  shouldShowSizePrompt (data) {
    const { items: lineItems = [], attributes = {} } = data

    if (attributes.multiple_sizes_prompt) return false
    if (!this.dataset.productId) return false

    const formData = new FormData(this.form)
    const addedVariantId = formData.get('id')
    const addedProductId = this.dataset.productId

    const matchedProductNotVariant = lineItems.some((lineItem) => {
      if (lineItem.product_id.toString() !== addedProductId.toString()) {
        // not matched product
        return false
      }
      if (
        lineItem.product_id.toString() === addedProductId.toString() &&
        lineItem.variant_id.toString() !== addedVariantId.toString()
      ) {
        // matched product but not variant
        return true
      }
      // matched product and variant
      return false
    })

    if (matchedProductNotVariant) {
      window.drawers.activeDrawerKey = 'size-prompt'
    }

    return matchedProductNotVariant
  }

  async addToCart (skipCart = false) {
    return window.BAO.Cart.addItemFromForm(this.skipCart, this.form)
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
